var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  viewBox: "0 0 462 784",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 462,
  height: 784,
  rx: 12,
  fill: "black",
  fillOpacity: 0.05
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M99 28C101.209 28 103 29.7909 103 32V38C103 40.2091 101.209 42 99 42H32C29.7909 42 28 40.2091 28 38V32C28 29.7909 29.7909 28 32 28H99Z",
  fill: "black",
  fillOpacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M430 50C432.209 50 434 51.7909 434 54V74C434 76.2091 432.209 78 430 78H32C29.7909 78 28 76.2091 28 74V54C28 51.7909 29.7909 50 32 50H430Z",
  fill: "black",
  fillOpacity: 0.1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M169 86C171.209 86 173 87.7909 173 90V96C173 98.2091 171.209 100 169 100H32C29.7909 100 28 98.2091 28 96V90C28 87.7909 29.7909 86 32 86H169Z",
  fill: "black",
  fillOpacity: 0.1
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M428 186C430.209 186 432 187.791 432 190V198C432 200.209 430.209 202 428 202H34C31.7908 202 30 200.209 30 198V190C30 187.791 31.7909 186 34 186H428Z",
  fill: "black",
  fillOpacity: 0.1
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M332 165C334.209 165 336 166.791 336 169V177C336 179.209 334.209 181 332 181H34C31.7909 181 30 179.209 30 177V169C30 166.791 31.7909 165 34 165H332Z",
  fill: "black",
  fillOpacity: 0.1
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M398 144C400.209 144 402 145.791 402 148V156C402 158.209 400.209 160 398 160H34C31.7909 160 30 158.209 30 156V148C30 145.791 31.7909 144 34 144H398Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgImgPlaceholder;